import {
  FETCH_INVOICE_COMPANIES,
  FETCH_INVOICE_COMPANIES_SUCCESS,
  FETCH_INVOICE_COMPANIES_FAIL,
  CREATE_INVOICE_COMPANY,
  CREATE_INVOICE_COMPANY_SUCCESS,
  CREATE_INVOICE_COMPANY_FAIL,
  UPDATE_INVOICE_COMPANY,
  UPDATE_INVOICE_COMPANY_SUCCESS,
  UPDATE_INVOICE_COMPANY_FAIL,
  DELETE_INVOICE_COMPANY,
  DELETE_INVOICE_COMPANY_SUCCESS,
  DELETE_INVOICE_COMPANY_FAIL,
  TEST_INVOICE_COMPANY_AADE,
  TEST_INVOICE_COMPANY_AADE_SUCCESS,
  TEST_INVOICE_COMPANY_AADE_FAIL,
  TEST_INVOICE_COMPANY_EPSILON,
  TEST_INVOICE_COMPANY_EPSILON_SUCCESS,
  TEST_INVOICE_COMPANY_EPSILON_FAIL,
  CLEAR_INVOICE_COMPANY_ERROR,
} from "./actionTypes"

const initialState = {
  companies: [],
  loading: false,
  saving: false,
  deleting: false,
  testing: false,
  testResult: null,
  error: null,
}

const invoiceCompanies = (state = initialState, action) => {
  switch (action.type) {
    // Fetch
    case FETCH_INVOICE_COMPANIES:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case FETCH_INVOICE_COMPANIES_SUCCESS:
      return {
        ...state,
        companies: action.payload,
        loading: false,
        error: null,
      }

    case FETCH_INVOICE_COMPANIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Create
    case CREATE_INVOICE_COMPANY:
      return {
        ...state,
        saving: true,
        error: null,
      }

    case CREATE_INVOICE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: [...state.companies, action.payload],
        saving: false,
        error: null,
      }

    case CREATE_INVOICE_COMPANY_FAIL:
      return {
        ...state,
        saving: false,
        error: action.payload,
      }

    // Update
    case UPDATE_INVOICE_COMPANY:
      return {
        ...state,
        saving: true,
        error: null,
      }

    case UPDATE_INVOICE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: state.companies.map(c =>
          c.id === action.payload.id ? action.payload : c
        ),
        saving: false,
        error: null,
      }

    case UPDATE_INVOICE_COMPANY_FAIL:
      return {
        ...state,
        saving: false,
        error: action.payload,
      }

    // Delete
    case DELETE_INVOICE_COMPANY:
      return {
        ...state,
        deleting: true,
        error: null,
      }

    case DELETE_INVOICE_COMPANY_SUCCESS:
      return {
        ...state,
        companies: state.companies.filter(c => c.id !== action.payload),
        deleting: false,
        error: null,
      }

    case DELETE_INVOICE_COMPANY_FAIL:
      return {
        ...state,
        deleting: false,
        error: action.payload,
      }

    // Test AADE
    case TEST_INVOICE_COMPANY_AADE:
      return {
        ...state,
        testing: true,
        testResult: null,
        error: null,
      }

    case TEST_INVOICE_COMPANY_AADE_SUCCESS:
      return {
        ...state,
        testing: false,
        testResult: { type: "aade", ...action.payload },
        error: null,
      }

    case TEST_INVOICE_COMPANY_AADE_FAIL:
      return {
        ...state,
        testing: false,
        testResult: null,
        error: action.payload,
      }

    // Test Epsilon
    case TEST_INVOICE_COMPANY_EPSILON:
      return {
        ...state,
        testing: true,
        testResult: null,
        error: null,
      }

    case TEST_INVOICE_COMPANY_EPSILON_SUCCESS:
      return {
        ...state,
        testing: false,
        testResult: { type: "epsilon", ...action.payload },
        error: null,
      }

    case TEST_INVOICE_COMPANY_EPSILON_FAIL:
      return {
        ...state,
        testing: false,
        testResult: null,
        error: action.payload,
      }

    // Clear Error
    case CLEAR_INVOICE_COMPANY_ERROR:
      return {
        ...state,
        error: null,
        testResult: null,
      }

    default:
      return state
  }
}

export default invoiceCompanies

// Selectors
export const selectInvoiceCompanies = (state) => state.invoiceCompanies.companies
export const selectActiveInvoiceCompanies = (state) =>
  state.invoiceCompanies.companies.filter(c => c.is_active)
export const selectDefaultInvoiceCompany = (state) =>
  state.invoiceCompanies.companies.find(c => c.is_default)
export const selectInvoiceCompaniesLoading = (state) => state.invoiceCompanies.loading
export const selectInvoiceCompaniesSaving = (state) => state.invoiceCompanies.saving
export const selectInvoiceCompaniesDeleting = (state) => state.invoiceCompanies.deleting
export const selectInvoiceCompaniesTesting = (state) => state.invoiceCompanies.testing
export const selectInvoiceCompaniesTestResult = (state) => state.invoiceCompanies.testResult
export const selectInvoiceCompaniesError = (state) => state.invoiceCompanies.error
